import { m8API } from 'services/production/m8';
import { SetPartnerClientNotesService } from 'types/services';

export const setPartnerClientNotes: SetPartnerClientNotesService = async (
  params
) => {
  const { clientId, notesText } = params;

  await m8API.partner.setClientComment({
    idClient: clientId,
    comment: notesText,
  });
};
